import React from "react";
import { BarChartWidget } from "../Graphs/BarChartWidget";
import { surveyService } from "../../services";

const SurveyAnsweredCount = (props) => {
    const getSurveyData = async () =>{
        let surveyAnswer= []   

        let surveyAnswerCount=await surveyService.getSurveyAnsweredCount(2)
        surveyAnswer.push(Number(surveyAnswerCount[0].count))
         surveyAnswerCount=await surveyService.getSurveyAnsweredCount(5)
        surveyAnswer.push(Number(surveyAnswerCount[0].count))
         surveyAnswerCount=await surveyService.getSurveyAnsweredCount(3)
        surveyAnswer.push(Number(surveyAnswerCount[0].count))
        surveyAnswerCount=await surveyService.getSurveyAnsweredCount(4)
        surveyAnswer.push(Number(surveyAnswerCount[0].count))
        surveyAnswerCount=await surveyService.getSurveyAnsweredCount(6)
        surveyAnswer.push(Number(surveyAnswerCount[0].count))
        surveyAnswerCount=await surveyService.getSurveyAnsweredCount(1)
        surveyAnswer.push(Number(surveyAnswerCount[0].count))
        
        let answerKey = ["Ponuda - stanovnici","Ponuda - JLS","Ponuda - institucije i gospodarski subjekti","Potražnja","Upitnik za stanovnike","Upitnik za predstavnike JLS-ova"]
        let value=surveyAnswer
        let sum = value.reduce((partialSum, a) => partialSum + a, 0);
        let result={answerKey,value,sum}
        setStatisticResult(result)
        
        
    }
    
    React.useEffect(() => {
        let fetchData = async () => {
           await Promise.all([getSurveyData()]);
        }
        
        fetchData();
    }, [])
    
    let [statistic, setStatisticResult] = React.useState([])
    
    return (
            <>
                <h2>Broj prijava korisnika: {statistic.sum}</h2>
                {statistic&&statistic.answerKey&&statistic.answerKey.map((item,index)=>(
                    <p>{item}: {statistic.value[index]}</p>
                    ))}


                    <BarChartWidget
                    id="stat-donut"
                    className="not-draggable"  
                    answerKey={statistic.answerKey}
                    value={statistic.value}
                    sum={statistic.sum}		
                    chartWidth={props?.style?.width?.replace('px', '') - 40}	
                    chartHeight={props?.style?.height?.replace('px', '') - 40}	  
  	
                    {...props}
                        >						
                    </BarChartWidget>
    
                    </>
        );
    
    }

export default SurveyAnsweredCount;